// extracted by mini-css-extract-plugin
module.exports = {"tableSorting":"styles_tableSorting__10p2J","sortAsc":"styles_sortAsc__14Pu9","sortingIcons":"styles_sortingIcons__39sDL"};